import { Button } from "@themes/pollinator/ui/Button";
import { CheckCircle } from "@themes/pollinator/ui/CheckCircle";

type Props = {
  label?: string;
  isAvailable: boolean;
  isCompleted: boolean;
  isDisabled: boolean;
  isButtonDisabled: boolean;
  onClick: () => void;
  /** When true, use secondary variant and compact sizing */
  compact?: boolean;
};

export function ProgramPhaseActionButton({
  label,
  isAvailable,
  isCompleted,
  isDisabled,
  isButtonDisabled = false,
  onClick,
  compact = false,
}: Props) {
  if (isDisabled) return null;

  return (
    <div className={compact ? "w-auto self-end mt-2" : "w-full md:w-auto"}>
      {isCompleted && !isAvailable ? (
        <div className="flex w-10">
          <CheckCircle isDisabled={isDisabled} />
        </div>
      ) : (
        <Button
          className={compact ? "w-fit" : "w-full mt-4 md:mt-0 md:w-fit"}
          variant={compact ? "secondary" : "primary"}
          onClick={onClick}
          data-testid="program-phase-action"
          disabled={isButtonDisabled}
        >
          {label}
        </Button>
      )}
    </div>
  );
}

export default ProgramPhaseActionButton;

